var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"effect-wrapper"},[(_vm.mode.drum)?_c('Drumroll',{attrs:{"close":_vm.close}}):_vm._e(),(_vm.mode.confetti)?_c('Confetti',{attrs:{"close":_vm.close}}):_vm._e(),(_vm.mode.hand)?_c('HandClap',{attrs:{"close":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }